// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2NcP3","content":"RecentSearches_content__bx82x"};